export enum DynamicFormInputTypes {
    text = 1,
    date = 2,
    number = 3,
    checkbox = 4,
    select = 5,
    currency = 6,
    textArea = 7,
    email = 8,
    password = 9,
    toggle = 10,
    radio = 11
}
